import MenuIcon from 'vue-material-design-icons/Menu.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import HeartOutlineIcon from 'vue-material-design-icons/HeartOutline.vue';
import CartOutlineIcon from 'vue-material-design-icons/CartOutline.vue';
import AccountBoxIcon from 'vue-material-design-icons/AccountBox.vue';

import cart from '@/modules/checkout/mixins/cart';
import user from '@/modules/user/mixins/user';

export default {
  mixins: [cart, user],
  computed: {
    actionIcons() {
      return [
        {
          name: 'menu',
          slot: MenuIcon,
          excludeHeader: true,
          title: this.$t('Menu'),
        },
        {
          name: 'search',
          slot: MagnifyIcon,
          title: this.$t('Search'),
        },
        {
          name: 'wishlist',
          slot: HeartOutlineIcon,
          hasBadge: true,
          badgeLabel: this.shoppingList.length,
          title: this.$t('Shopping List'),
        },
        {
          name: 'cart',
          hasBadge: true,
          badgeLabel: this.cart.length,
          slot: CartOutlineIcon,
          title: this.$t('Shopping Cart'),
        },
        {
          name: 'user',
          slot: AccountBoxIcon,
          title: this.$t('My Account'),
        },
      ];
    },
  },
};
